import Drawer from '@material-ui/core/Drawer';
import Grid from '@material-ui/core/Grid';
import Link from '@material-ui/core/Link';
import Typography from '@material-ui/core/Typography';
import ArrowBack from '@material-ui/icons/ArrowBack';
import React, { FC } from 'react';

import StyledIconButton from '../Buttons/IconButton';
import CloseIcon from '../images/close.svg';
import useStyles from './styles';

export interface BottomSheetProps {
  children: JSX.Element;
  /** Translated name for the close button, e.g. "Close". */
  closeLabel: string;
  hasBackButton?: boolean;
  open: boolean;
  title?: string;
  onBack?: () => void;
  onClose: () => void;
}

export const BottomSheet: FC<BottomSheetProps> = ({
  open,
  children,
  closeLabel,
  title,
  onClose,
  hasBackButton,
  onBack,
}) => {
  const classes = useStyles();

  return (
    <Drawer anchor="bottom" classes={{ paper: classes.paper }} disableEnforceFocus open={open}>
      <>
        <Grid className={classes.header} container>
          {hasBackButton && (
            <StyledIconButton className={classes.backButton} component={Link} onClick={onBack}>
              <ArrowBack color="secondary" />
            </StyledIconButton>
          )}
          <Grid
            alignItems="center"
            className={classes.titleContainer}
            container
            justify="center"
            wrap="nowrap"
            zeroMinWidth
          >
            {!React.isValidElement(title) ? (
              <Typography align="center" noWrap variant="h3">
                {title}
              </Typography>
            ) : (
              title
            )}
            <StyledIconButton aria-label={closeLabel} className={classes.closeButton} onClick={onClose}>
              <img alt="" src={CloseIcon} />
            </StyledIconButton>
          </Grid>
        </Grid>
        <Grid className={classes.bodyContainer}>{children}</Grid>
      </>
    </Drawer>
  );
};
